import React from "react";
import loginLeft from "../../assets/images/login-left.png";
import { Link } from "react-router-dom";
const Auth = ({ children }) => {
  return (
    <div className="LoginArea">
      <div className="LoginBox">
        <div className="LoginRight">
          <figure>
            <img src={loginLeft} />
          </figure>
          <h5>
            Learn, Grow, Prospuh: <br /> Kickstart Your Journey with
            Learn2Prospuh!
          </h5>
          <ul
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <li>
              <Link
                to="/termsCondition"
                style={{
                  color: "#0d6efd",
                }}
              >
                Terms &amp; Condition
              </Link>
            </li>
            <li>
              <Link
                to={"/privacyPolicy"}
                style={{
                  color: "#0d6efd",
                }}
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
          {/* <h6>
            Seize the moment and help shape the future by starting a career in
            blockchain now
          </h6> */}
        </div>
        <div className="LoginLeft">{children}</div>
      </div>
      {/* <ul>
        <li>
          <a href="javascript:void(0);">Terms &amp; Condition</a>
        </li>
        <li>
          <a href="javascript:void(0);">Privacy Policy</a>
        </li>
        <li>
          <a href="javascript:void(0);">Help</a>
        </li>
        <li>
          <select>
            <option>English</option>
            <option>Hindi</option>
          </select>
        </li>
      </ul> */}
      <p
        style={{
          marginTop: "30px",
        }}
      >
        © 2024 Learn 2 Prospuh. All Right Reserved.
      </p>
    </div>
  );
};

export default Auth;
